<template>
  <div class="wrap">
    <div class="top">
      <div class="notice">
        <img src="../../assets/images/payResult/sucessICON.png" alt />
        <span class="right">
          <span class="bold">支付成功!</span>
          <span class="desc">感谢您的购买</span>
        </span>
      </div>
      <div class="listWrap">
        <div class="listContainer">
          <div class="line"></div>
          <div class="list">
            <div class="price">
              <span class="dallor">￥</span>
              <span class="amount">{{aItem.sum_amount}}</span>
            </div>
            <div class="bottomArea">
              <div class="item">订单编号：{{aItem.show_nbr}}</div>
              <div class="item">下单时间：{{aItem.create_time}}</div>
              <van-button class="look" @click="codeShow = true">关注有米</van-button>
            </div>
          </div>
        </div>
      </div>
      <img v-if="gameState==='0'" @click="toTurn" class="tuenImg" src="../../assets/images/orderTurn.png" alt />
      <div class="shareBtnBox">
        <div class="shareLeft">
          <img src="../../assets/images/payResult/smile.png" alt />
          <span>你的好友都在疯抢中，库存有限</span>
        </div>
        <div class="shareRight" @click="goqrcode">
          <span>分享晒单</span>
          <img src="../../assets/images/material/back.svg" alt />
        </div>
      </div>
    </div>
    <div class="bottom">
      <van-button class="btn red" @click="toOrder">查看订单</van-button>
      <van-button class="btn default" @click="toHome">回到首页</van-button>
    </div>
    <van-popup v-model="codeShow" position="bottom" :overlay="true" @click-overlay="codeShow=false">
      <div class="codeBox">
        <div class="title">关注有米不迷路</div>
        <img src="../../assets/images/payResult/expressCode.png" alt />
        <span>
          长按识别
          <br />添加有米专属运营经理微信，获取专属服务
        </span>
        <van-button class="noticeBtn" @click="noNotice">我知道了，不再提醒</van-button>
      </div>
    </van-popup>

    <div class="container" v-show="qrcodeshare">
      <van-popup v-model="showshare" @click-overlay="colseshare">
        <div class="shareBox" ref="shareBox">
          <img :src="shareImg || ''" alt="" class="shareImg" />
        </div>
      </van-popup>
      <div class="hold" v-if="showshare">
        <!-- <div @click="wechatShareBtn1">
          <img src="../../assets/images/Sharing_Friends.png" /><br />
          <span>分享好友</span>
        </div>
        <div @click="wechatShareBtn2">
          <img src="../../assets/images/Sharing_Friends2.png" /><br />
          <span>分享朋友圈</span>
        </div> -->
        <div @click="downloadImg">
          <img src="../../assets/images/Save_pictures.png" /><br />
          <a :dowanload="htmlUrl">下载图片</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        aItem: {},
        orderNbr: this.$route.query.orderNbr || "",
        state: this.$route.query.state || "",
        group_leader_nbr: this.$route.query.group_leader_nbr || "",
        supNbr: this.$route.query.supNbr || "",
        gameState: '',
        codeShow: false,

        qrCode: '',
        shareImg: '',
        qrcodeshare: false, //分享显隐
        showshare: false, //是否显示分享图片
      };
    },
    methods: {
      goqrcode() {
        let that = this
        if (this.shareImg) {
          this.qrcodeshare = true;
          this.showshare = true;
        } else {
          this.createCommodityCode();
        }
      },
      createCommodityCode() {
        let that = this;
        let toast = that.$toast.loading({
          mask: false,
          message: "图片生成中...",
          duration: 0,
        });
        that.$post("/api/wechat/gzh/generateNewQRCode", {
            page: that.aItem.commodity[0].rule_type=='1'?"/listdetail":'/sourceListdetail',
            supNbr: that.supNbr,
            nbr: that.aItem.commodity[0].commodity_nbr,
          })
          .then((res) => {
            let resp = res.object.resp;
            if (res.code == "200") {
              if (resp.resp_code == "0" && resp.resp_result == "0") {
                that.qrCode = resp.qrcode;
                that.createCommodityShareUrl(toast);
              } else {
                toast.clear();
                that.$toast({
                  message: resp.resp_msg,
                  duration: 2000,
                });
              }
            } else {
              toast.clear();
              that.$toast({
                message: res.message,
                duration: 2000,
              });
            }
          })
          .catch((err) => {
            toast.clear();
            that.$toast({
              message: err.message,
              duration: 2000
            });
          });
      },
      createCommodityShareUrl(toast) {
        let that = this;
        let orderInfo = that.aItem
        let commodity = orderInfo.commodity[0];
        let createTime = `${orderInfo.create_time.substring(0, 4)}年${orderInfo.create_time.substring(5, 7)}月${orderInfo.create_time.substring(8, 10)}日${orderInfo.create_time.substring(10)}`
        that.$post("/api/image/share/generateYMOrderShareImage", {
            "commodityUrl": commodity.commodity_first_pic,
            "codeUrl": that.qrCode,
            "orderNbr": `${orderInfo.show_nbr.substring(0,orderInfo.show_nbr.length-5)}*****`,
            "createTime": createTime,
            "name": `${orderInfo.contacts.substring(0, 1)}**`,
            "phoneNo": `${orderInfo.phone_no.substring(0, 3)}****${orderInfo.phone_no.substring(7)}`,
            "address": `${orderInfo.full_address.substring(0, 6)}***`,
            "commodityName": encodeURIComponent(commodity.commodity_name),
            "propertyName": commodity.property,
            "sellPrice": commodity.show_price,
            "quantity": commodity.quantity,
            "sumAmount": orderInfo.show_amount,
          })
          .then((res) => {
            toast.clear();
            let resp = res.object.resp;
            if (res.code == "200") {
              if (resp.resp_code == "0" && resp.resp_result == "0") {
                that.shareImg = resp.imageUrl;
                that.qrcodeshare = true;
                that.showshare = true;
              } else {
                that.$toast({
                  message: resp.resp_msg,
                  duration: 2000,
                });
              }
            } else {
              that.$toast({
                message: res.message,
                duration: 2000,
              });
            }
          })
          .catch((err) => {
            toast.clear();
            that.$toast({
              message: "分享图合成失败，请重试",
              duration: 2000,
            });
          });
      },
      colseshare() {
        this.$toast.clear();
        this.qrcodeshare = false;
        this.showshare = false;
      },
      // 下载提示
      downloadImg() {
        this.$toast({
          message: "请长按保存图片",
          duration: 2000,
        });
      },
      toTurn() {
        this.$router.replace({ path: '/turn' });
      },
      noNotice() {
        localStorage.setItem("noNotice", 1);
        this.codeShow = false;
      },
      detail() {
        let toast = this.$toast({
          mask: false,
          duration: 0,
          type: "loading"
        });
        this.$commonPost({
          jydm: "flow_30011",
          flow_30011: {
            order_nbr: this.orderNbr,
            wechat_version: 1
          }
        })
          .then(response => {
            let arr = [];
            if (response.commodity) {
              if (response.commodity.length > 0) {
                arr = response.commodity;
              } else {
                arr.push(response.commodity);
              }
            }
            response.commodity = arr
            this.aItem = response;
            this.gameState = response.is_gift;
            this.goqrcode()
            toast.clear();
          })
          .catch(err => {
            this.$toast({
              message: err.message,
              duration: 2000
            });
          });
      },
      toOrder() {
        this.$router.replace({
          path: "/myorder",
          query: {
            index: 2,
            supNbr: this.supNbr
          }
        });
      },
      toHome() {
        this.$router.replace({
          path: "/index",
        });
      },
    },
    mounted() {
      this.codeShow = true;
      this.detail()
    }
  };
</script>

<style scoped>
  .wrap {
    width: 100%;
    background: #f5f5f5;
    min-height: 100vh;
    position: relative;
  }

  .top {
    width: 100%;
    height: 2.98rem;
    background: #e52b25;
    padding-top: 0.01rem;
    position: relative;
  }

  .top .notice {
    margin-top: 0.58rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .top .notice img {
    width: 1.16rem;
    height: 1.16rem;
  }

  .top .notice .right {
    display: flex;
    flex-direction: column;
    color: #fff;
    margin-left: 0.18rem;
  }

  .top .notice .right .bold {
    font-size: 0.34rem;
    line-height: 0.48rem;
    font-weight: 600;
  }

  .top .notice .right .desc {
    margin-top: 0.06rem;
    font-size: 0.24rem;
    line-height: 0.33rem;
    font-weight: 500;
  }

  .top .listWrap {
    margin-top: .56rem;
    width: 100%;
  }

  .listContainer {
    position: relative;
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 100%;
  }

  .line {
    width: 7.1rem;
    height: 0.2rem;
    background: #cf1212;
    border-radius: 0.125rem;
  }

  .list {
    position: relative;
    margin-top: -0.1rem;
    z-index: 2;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 6.74rem;
    height: 4.92rem;
    background: #fff;
    box-shadow: 0 0.02rem 0.08rem 0.06rem rgba(0, 0, 0, 0.04);
    border-radius: 0 0 0.1rem 0.1rem;
  }

  .list::after {
    content: "";
    position: absolute;
    top: 0;
    width: 6.74rem;
    height: 0.3rem;
    background-image: linear-gradient(0deg,
        rgba(255, 255, 255, 0) 10%,
        rgba(229, 43, 37, 0.6) 99%);
    z-index: 3;
  }

  .list .price {
    margin-top: 0.75rem;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #333;
    font-weight: 500;
  }

  .list .price .dallor {
    font-size: 0.24rem;
    line-height: 1.5;
  }

  .list .price .amount {
    font-size: 0.5rem;
    line-height: 1.4;
    margin-left: 0.04rem;
  }

  .bottomArea {
    width: 5.54rem;
    border-top: 1px dashed #979797;
    margin-top: 0.35rem;
    padding-top: 0.01rem;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .bottomArea .item {
    width: 100%;
    display: flex;
    align-items: center;
    line-height: 1.5;
    font-size: 0.28rem;
    color: #999;
    margin-top: 0.42rem;
  }

  .look {
    width: 1.8rem;
    height: 0.54rem;
    font-size: 0.22rem;
    line-height: 1.5;
    color: #e52b25;
    border: 0;
    background: rgba(255, 8, 0, 0.05);
    border-radius: 0.49rem;
    margin-top: 0.48rem;
  }

  .bottom {
    position: fixed;
    bottom: 0.5rem;
    display: flex;
    justify-content: space-between;
    padding: 0 0.38rem;
    box-sizing: border-box;
    width: 100%;
  }

  .bottom .btn {
    width: 3.3rem;
    height: 0.78rem;
    border-radius: 0.49rem;
    font-size: 0.26rem;
    font-weight: 500;
    border: 0;
    box-sizing: border-box;
    line-height: 1.5;
  }

  .bottom .btn.red {
    background: #e52b25;
    color: #fff;
  }

  .bottom .btn.default {
    border: 1px solid #e5e5e5;
    color: #333;
  }

  .codeBox {
    width: 100vw;
    height: 7rem;
    border-top-left-radius: 0.2rem;
    border-top-right-radius: 0.2rem;
    background: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .codeBox .title {
    font-size: 0.36rem;
    font-weight: 500;
    line-height: 0.5rem;
    margin-top: 0.42rem;
  }

  .codeBox img {
    width: 2.7rem;
    height: 2.7rem;
    border: 1px solid #979797;
    margin-top: 0.49rem;
  }

  .codeBox span {
    font-size: 0.24rem;
    font-weight: 500;
    line-height: 0.33rem;
    margin-top: 0.49rem;
    text-align: center;
  }

  .noticeBtn {
    width: 6.28rem;
    height: 0.78rem;
    background: #e52b25;
    border: 0;
    border-radius: 0.49rem;
    color: #fff;
    font-size: 0.26rem;
    line-height: 1.5;
    margin-top: 0.6rem;
  }

  .tuenImg {
    display: block;
    margin: .38rem auto 0;
    width: 6.74rem;
    height: 1.68rem;
  }

  .shareBtnBox {
    width: 6.74rem;
    margin: .2rem auto 0;
    height: .74rem;
    padding: 0 .14rem;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    background: #fff;
    border-radius: .08rem;
  }

  .shareLeft {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }

  .shareLeft img {
    width: .44rem;
    height: .44rem;
    margin-right: .14rem;
  }

  .shareLeft span {
    font-size: .26rem;
    color: #333;
  }

  .shareRight {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }

  .shareRight span {
    font-size: .26rem;
    color: #E52B25;
  }

  .shareRight img {
    width: .28rem;
    height: .28rem;
    transform: rotate(180deg);
  }

  .container {
    position: fixed;
    top: 0rem;
    left: 0rem;
    z-index: 9;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
  }

  .container .van-popup {
    width: 100%;
    height: 8.96rem;
    overflow: hidden;
    background: transparent;
    top: 40%;
  }

  .container .shareBox {
    height: 8.96rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    overflow-y: scroll;
  }

  .container .shareImg {
    width: 6.12rem;
    margin-left: 0.69rem;
  }

  .container .shareImg:last-child {
    margin-right: 0.69rem;
  }

  .hold {
    width: 100%;
    height: 2.48rem;
    background: #FFFFFF;
    border-top-left-radius: .3rem;
    border-top-right-radius: .3rem;
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 999999;
    display: flex;
    justify-content: center;
  }

  .hold div {
    width: 2.5rem;
    flex-direction: column;
    justify-content: center;
    text-align: center;
  }

  .hold img {
    width: 1.2rem !important;
    height: 1.2rem !important;
    margin-top: 0.33rem;
    margin-bottom: 0.2rem;
  }
</style>
<style lang="stylus" scoped>
  .wrap>>>.van-popup {
    background: transparent !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/index/payResultFollow.vue